import { api } from "./axios";
import { Address } from "viem";

export type RegisterResponse = { success: boolean };
export type StatusResponse = { registered: boolean };
export type ProofResponse = { proof: Address[] };

export const registerApi = async (
  fid: number,
  address: string
): Promise<RegisterResponse> => {
  const { data } = await api.post("/whitelist/register", { fid, address });
  return data;
};

export const getRegisterStatusByFidApi = async (
  fid: number
): Promise<StatusResponse> => {
  const { data } = await api.get(`/whitelist/status/fid/${fid}`);
  return data;
};

export const getRegisterStatusByAddressApi = async (
  address: string
): Promise<StatusResponse> => {
  const { data } = await api.get(`/whitelist/status/address/${address}`);
  return data;
};

export const getProofApi = async (address: string): Promise<ProofResponse> => {
  const { data } = await api.get(`/whitelist/proof/${address}`);
  return data;
};
